import React from 'react';
import QRCodeSVG from '../../elements/QRCode';
import { RenderExpiration } from './Expiration';
import { RenderIdaVuelta } from './IdaVuelta';
export var ServiceOfPacket = function (_a) {
    var item = _a.item, ticket = _a.ticket, index = _a.index, isCollaborator = _a.isCollaborator;
    return (React.createElement("div", { key: ticket.numero, style: { borderStyle: 'outset', padding: '40px', margin: '10px 20px' } },
        React.createElement("div", { style: { width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: index % 2 === 0 ? 'flex-end' : 'flex-start', } },
            isCollaborator && React.createElement("p", { style: { marginBottom: 0 } }, 'Servicio ofrecido por:'),
            isCollaborator && React.createElement("p", { style: { marginTop: 0 } }, ticket.operatorName),
            React.createElement("p", null, "".concat(ticket.stretchName)),
            React.createElement("span", null, "".concat(ticket.numero)),
            React.createElement("span", null,
                React.createElement(QRCodeSVG, { value: ticket.numero, size: 80, level: 'H' }))),
        React.createElement(RenderExpiration, { item: ticket }),
        item.vuelta && !item.hoponHopoff && React.createElement(RenderIdaVuelta, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/ServiceOfPacket.tsx
// module id = 1163
// module chunks = 0